export default __webpack_public_path__ + "media/dropdown-icon-right.4b35d16b.svg";